import React, { useState } from "react";
import {
  RiCloseLine,
  RiMapPinLine,
  RiCheckLine,
  RiArrowRightLine,
  RiTimeLine,
  RiMapPinTimeLine,
} from "react-icons/ri";
import styles from "./BusBoardingPoints3.module.css";

const BusBoardingPoints3 = ({ bus, onClose, onSubmit, autoProceed = false }) => {
  const [selectedBoarding, setSelectedBoarding] = useState(null);
  const [selectedDropping, setSelectedDropping] = useState(null);

  const handleSubmit = () => {
    if (selectedBoarding && selectedDropping) {
      onSubmit(selectedBoarding, selectedDropping);
    }
  };

  const handleBoardingSelect = (point) => {
    setSelectedBoarding(point);
  };

  const handleDroppingSelect = (point) => {
    setSelectedDropping(point);
  };

  // Mock data preserved exactly from your master code
  const boardingPoints = bus.boardingPoints || [
    {
      id: "bp1",
      location: "Mumbai Central",
      time: "22:00",
      pointName: "Mumbai Central Bus Stand",
      landmark: "Near Railway Station",
      address: "Mumbai Central, Mumbai, Maharashtra 400008",
      distance: "0 km",
      facilities: ["Waiting Lounge", "Food Court", "Restrooms"],
    },
    {
      id: "bp2",
      location: "Andheri",
      time: "22:30",
      pointName: "Andheri Bus Stop",
      landmark: "Near Metro Station",
      address: "Andheri East, Mumbai, Maharashtra 400069",
      distance: "15 km",
      facilities: ["Parking", "ATM"],
    },
    {
      id: "bp3",
      location: "Bandra",
      time: "23:00",
      pointName: "Bandra Bus Depot",
      landmark: "Opposite Bandra Station (W)",
      address: "Bandra West, Mumbai, Maharashtra 400050",
      distance: "25 km",
      facilities: ["Waiting Area", "Food Stalls"],
    },
  ];

  const droppingPoints = bus.droppingPoints || [
    {
      id: "dp1",
      location: "Pune Station",
      time: "06:00",
      pointName: "Pune Railway Station",
      landmark: "Near Shivajinagar",
      address: "Pune Station, Pune, Maharashtra 411001",
      distance: "0 km",
      facilities: ["Auto/Taxi Stand", "Restaurants"],
    },
    {
      id: "dp2",
      location: "Swargate",
      time: "06:30",
      pointName: "Swargate Bus Stand",
      landmark: "Main Bus Terminal",
      address: "Swargate, Pune, Maharashtra 411042",
      distance: "5 km",
      facilities: ["Bus Connections", "Shopping"],
    },
    {
      id: "dp3",
      location: "Hinjewadi",
      time: "07:00",
      pointName: "Hinjewadi IT Park",
      landmark: "Phase 1, Near Tech Park",
      address: "Hinjewadi, Pune, Maharashtra 411057",
      distance: "25 km",
      facilities: ["Corporate Drop", "Taxi Service"],
    },
  ];

  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* Editorial Header */}
        <div className={styles.modalHeader}>
          <div className={styles.headerTitleGroup}>
            <span className={styles.topTag}>CONFIGURATION</span>
            <h3 className={styles.modalTitle}>
              Point <span className={styles.italic}>Selection</span>
            </h3>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            <RiCloseLine />
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.pointsGrid}>
            {/* Boarding Points Column */}
            <div className={styles.pointsColumn}>
              <h4 className={styles.sectionTitle}>
                01. Boarding Point
              </h4>
              <div className={styles.pointsList}>
                {boardingPoints.map((point) => (
                  <div
                    key={point.id}
                    className={`${styles.pointCard} ${
                      selectedBoarding?.id === point.id ? styles.cardActive : ""
                    }`}
                    onClick={() => handleBoardingSelect(point)}
                  >
                    <div className={styles.cardHeader}>
                      <span className={styles.pointTime}>
                        <RiTimeLine /> {formatTime(point.time)}
                      </span>
                      <span className={styles.distBadge}>{point.distance}</span>
                    </div>
                    <div className={styles.pointName}>{point.pointName}</div>
                    <div className={styles.pointAddress}>{point.address}</div>
                    {selectedBoarding?.id === point.id && (
                        <div className={styles.selectedMarker}><RiCheckLine /></div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Dropping Points Column */}
            <div className={styles.pointsColumn}>
              <h4 className={styles.sectionTitle}>
                02. Dropping Point
              </h4>
              <div className={styles.pointsList}>
                {droppingPoints.map((point) => (
                  <div
                    key={point.id}
                    className={`${styles.pointCard} ${
                      selectedDropping?.id === point.id ? styles.cardActive : ""
                    }`}
                    onClick={() => handleDroppingSelect(point)}
                  >
                    <div className={styles.cardHeader}>
                      <span className={styles.pointTime}>
                        <RiTimeLine /> {formatTime(point.time)}
                      </span>
                      <span className={styles.distBadge}>{point.distance}</span>
                    </div>
                    <div className={styles.pointName}>{point.pointName}</div>
                    <div className={styles.pointAddress}>{point.address}</div>
                    {selectedDropping?.id === point.id && (
                         <div className={styles.selectedMarker}><RiCheckLine /></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Action Footer */}
        <div className={styles.modalFooter}>
          <div className={styles.summaryInfo}>
            {selectedBoarding && selectedDropping ? (
                <p>Ready to finalize your journey points.</p>
            ) : (
                <p>Please select your preferred locations.</p>
            )}
          </div>
          <div className={styles.btnGroup}>
            <button className={styles.cancelBtn} onClick={onClose}>Cancel</button>
            <button
                className={styles.confirmBtn}
                disabled={!selectedBoarding || !selectedDropping}
                onClick={handleSubmit}
            >
                Confirm Points <RiArrowRightLine />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusBoardingPoints3;